import React from 'react';

let faqEN = ({onMenuToggle}) => {
	return <div>
		<h2>Using Enjoy!</h2>
		<div className="faq-warning">
			<p>Premium Club and Bizz Club will be discontinued on 30/11/2019.<br/> You can <a
				href="https://www.proximus.be/support/en/id_sfaqr_club_exchange/personal/support/myproximus-and-billing/premium-club/premium-club-points/check-and-redeem-your-premium-club-points.html">redeem
				your Premium Club points</a> or <a
				href="https://www.proximus.be/support/en/id_sfaqs_club_exchange/self-employed-and-small-companies/support/myproximus-and-billing/bizz-club/bizz-club-points/check-and-redeem-your-bizz-club-points.html">Bizz
				Club points</a> (if you're a business customer) until 30/11/2019.</p>
		</div>
		<p>Premium Club and Bizz Club are being replaced by Enjoy! As a Proximus customer, you have two types of
			exclusive advantages in MyProximus: Enjoy! experiences and Enjoy! deals.</p>
		<h2 id="howto">How do you consult Enjoy! </h2>
		<p>To consult the discounts and competitions of Enjoy! you must <a
			href="https://www.proximus.be/support/en/id_sfaqs_mypx_register/self-employed-and-small-companies/support/myproximus-and-billing/myproximus/myproximus-application/how-to-register-for-myproximus.html">be
			registered </a>and <a
			href="https://www.proximus.be/support/en/id_sfaqr_mypx_login/personal/support/myproximus-and-billing/myproximus/myproximus-website/how-do-you-log-in-to-myproximus.html">logged
			in</a> to MyProximus. <a
			href="https://www.proximus.be/support/en/id_sfaqs_mypx_no_access/self-employed-and-small-companies/support/myproximus-and-billing/myproximus/myproximus-website/no-access-to-myproximus.html">Can't
			register or log in?</a></p>
		<p>You can then view the Enjoy! offers on MyProximus (via the app or web):</p>
		<ol>
			<li>Via the app: in the MyProximus app, tap More and then My Rewards.<br/> Via the website: click the button
				below and sign in.<br/> <a
					href="https://www.proximus.be/myproximus/en/Personal/services/My-Rewards__.html">View Enjoy!</a>
			</li>
			<li>Click Enjoy! experiences or Enjoy! deals:
				<ul>
					<li>Enjoy! experiences: participate in one or more competitions. The winners are informed by
						e-mail.
					</li>
					<li>Enjoy! deals: benefit from exceptional discounts. Check how long your discount or reward is
						valid for. You can only use it once.
					</li>
				</ul>
			</li>
		</ol>
		<h2>It doesn't work or you have a problem?</h2>
		<p>Check your situation. We'll help you further.</p>
		<div className="panel-group" id="accordion">
			<div className="panel panel-default">
				<div className="panel-heading">
					<a className="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseOne">
						Can't find Enjoy! or can't access it?
					</a>
				</div>
				<div id="collapseOne" className="panel-collapse collapse in">
					<p>Check if you&rsquo;re in this situation:</p>
					<ul>
						<li>In MyProximus, if you don't see your name at the top, then you are not correctly <a
							href="https://www.proximus.be/support/en/id_sfaqr_mypx_login/personal/support/myproximus-and-billing/myproximus/myproximus-website/how-do-you-log-in-to-myproximus.html">logged
							in</a> or <a
							href="https://www.proximus.be/support/en/id_sfaqs_mypx_register/self-employed-and-small-companies/support/myproximus-and-billing/myproximus/myproximus-application/how-to-register-for-myproximus.html">registered</a>.
						</li>
						<li>If your mobile is paid by your work, you can't participate in Enjoy!</li>
						<li>You must be over 18 years old.</li>
					</ul>
				</div>
			</div>

			<div className="panel panel-default">
				<div className="panel-heading">
					<a className="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo">
						Can't consult a specific Enjoy! deal or Enjoy! experience?
					</a>
				</div>
				<div id="collapseTwo" className="panel-collapse collapse in">
					<p>Enjoy! deals and Enjoy! experiences have a limited validity and stock, so don't dawdle. However,
						new discounts and experiences are added regularly, so be sure to consult Enjoy! frequently, as
						described <a href="#howto">above</a>.</p>
				</div>
			</div>

			<div className="panel panel-default">
				<div className="panel-heading">
					<a className="accordion-toggle" data-toggle="collapse" data-parent="#accordion"
					   href="#collapseThree">
						Can't find the code, voucher or link for your Enjoy! deal?
					</a>
				</div>
				<div id="collapseThree" className="panel-collapse collapse in">
					<p>You can recover this information until its expiry date on MyProximus. Proceed as follows:</p>
					<ol>
						<li>Consult Enjoy! as described <a href="#howto">above</a>.</li>
						<li>Click your Enjoy! deal. There you will find the code, voucher or link.</li>
					</ol>
					<p>You can only use your discount or reward once before the expiry date, and can't combine them.</p>
				</div>
			</div>

			<div className="panel panel-default">
				<div className="panel-heading">
					<a className="accordion-toggle" data-toggle="collapse" data-parent="#accordion"
					   href="#collapseFour">
						Your code for an Enjoy! deal doesn't work?
					</a>
				</div>
				<div id="collapseFour" className="panel-collapse collapse in">
					<p>Once the code has been used or its expiry date has passed, it will no longer work. However, if
						your code doesn't work before the expiry date, please <a
							href="http://www.proximus.be/contact">contact</a> us by chat or e-mail. Make sure you have
						your <a
							href="https://www.proximus.be/support/en/id_sfaqr_mypx_credentials/personal/support/myproximus-and-billing/myproximus/myproximus-website/customer-number-activation-code-and-date.html">customer
							number</a> at hand.</p>
				</div>
			</div>

			<div className="panel panel-default">
				<div className="panel-heading">
					<a className="accordion-toggle" data-toggle="collapse" data-parent="#accordion"
					   href="#collapseFive">
						You didn't receive the winning tickets of your Enjoy! experience?
					</a>
				</div>
				<div id="collapseFive" className="panel-collapse collapse in">
					<p>Please <a href="http://www.proximus.be/contact">contact</a> us by chat or e-mail. Make sure you
						have your <a
							href="https://www.proximus.be/support/en/id_sfaqr_mypx_credentials/personal/support/myproximus-and-billing/myproximus/myproximus-website/customer-number-activation-code-and-date.html">customer
							number</a> at hand.</p>
				</div>
			</div>

		</div>
	</div>
};

export default faqEN;